export enum RoleStatus {
  None = 0,
  Active,
  Inactive,
}
